/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyremaininglabel3Inputs */

const en_dropdailyremaininglabel3 = /** @type {(inputs: Dropdailyremaininglabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left`)
};

const de_dropdailyremaininglabel3 = /** @type {(inputs: Dropdailyremaininglabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übrig`)
};

/**
* | output |
* | --- |
* | "Left" |
*
* @param {Dropdailyremaininglabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyremaininglabel3 = /** @type {((inputs?: Dropdailyremaininglabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyremaininglabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyremaininglabel3(inputs)
	return de_dropdailyremaininglabel3(inputs)
});
export { dropdailyremaininglabel3 as "dropDailyRemainingLabel" }